const REFETCH_PADDING_MS = 20 * 1000

const randomPadding = () => {
  const min = REFETCH_PADDING_MS * 0.5
  const max = REFETCH_PADDING_MS * 1.5
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const calculateNextRefresh = (exp?: number | null) => {
  if (!exp) return
  return (exp * 1000) - randomPadding()
}
